module.exports = __webpack_public_path__ + "static/img/jewellery_home_bracelet.44b9fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/jewellery_home_bracelet.png
// module id = jDJF
// module chunks = 0